/**
 * Icon-name compatibility for the Material Icons -> Material Symbols migration.
 *
 * Point category icons are persisted per tenant (PointCategory.matIcon) and were originally
 * chosen from the Material Icons catalogue. Almost every one of those names also exists in
 * Material Symbols, so stored values normally render unchanged.
 *
 * The exceptions are the names below: they exist in Material Icons but were not carried over
 * to Material Symbols, so without a rename they would render as literal text. The list is
 * complete - it was derived by diffing the Material Icons catalogue against the shipped
 * MaterialSymbolsOutlined codepoints file, so there is no need for a catch-all fallback.
 *
 * Do NOT use icon-picker/metadata.json to decide Symbols support. Its unsupported_families
 * data is stale and wrongly marks ~700 valid Symbols icons (place, phone, expand_more,
 * file_download, launch, ...) as unsupported. Use SYMBOLS_ICON_NAMES instead.
 */
export const ICON_RENAMES: Readonly<Record<string, string>> = {
    catching_pokemon: 'sports_esports',
    discount: 'percent',
    fire_hydrant_alt: 'fire_hydrant',
    fitbit: 'watch',
    miscellaneous_services: 'home_repair_service',
    no_cell: 'signal_cellular_off',
    panorama_horizontal_select: 'panorama_horizontal',
    panorama_photosphere_select: 'panorama_photosphere',
    panorama_vertical_select: 'panorama_vertical',
    panorama_wide_angle_select: 'panorama_wide_angle',
    person_add_alt_1: 'person_add',
    person_remove_alt_1: 'person_remove',
    pix: 'payments',
    play_circle_filled: 'play_circle',
    play_circle_outline: 'play_circle',
    signal_wifi_statusbar_connected_no_internet_4: 'signal_wifi_bad',
};

export const IconNameUtils = {
    resolve(iconName: string | undefined | null): string {
        if (!iconName) {
            return '';
        }

        return Object.hasOwn(ICON_RENAMES, iconName) ? ICON_RENAMES[iconName] : iconName;
    },
};
